export default "__VITE_ASSET__6v1tsc6f__"